const globalRolesRoute = {
	path: ':codeProject/roles-globales',
	name: 'roles-global',
	meta: {
		title: 'Roles Globales',
	},
	component: () => import('@/pages/roles/page-global-roles'),
};

export default globalRolesRoute;



// WEBPACK FOOTER //
// ./src/router/globalRoles.js